@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- society -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.society' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.billingAccount.name">
        </div>
      </div>
      <!-- contractNumber -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.contractNumber' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.name">
        </div>
      </div>
      <!-- contractDenomination -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.contractDenomination' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.name">
        </div>
      </div>
      <!-- currency -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.currency' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.currency">
        </div>
      </div>
      <!-- contractStart -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.contractStart' | translate }}
                </label>
          <p-datepicker [(ngModel)]='startDate' [readonlyInput]='true' [showTime]='true'
              [style]="{'width':'200px'}" dateFormat='{{i18n.dateFormat}}' showIcon='true'
            appendTo='body'></p-datepicker>
            <!-- <input type="text" class="form-control custom-input" [(ngModel)]="startDate"> -->
        </div>
      </div>
      <!-- contractEnd -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.contractEnd' | translate }}
                </label>
          <p-datepicker [(ngModel)]='endDate' [readonlyInput]='true' [showTime]='true'
              [style]="{'width':'200px'}" dateFormat='{{i18n.dateFormat}}' showIcon='true'
            appendTo='body'></p-datepicker>
            <!-- <input type="text" class="form-control custom-input" [(ngModel)]="endDate"> -->
        </div>
      </div>
      <!-- bpCode -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.bpCode' | translate }}
                </label>
          <input type="text" class="form-control custom-input"
              [(ngModel)]="entity.financing.provider.providerParameters.codeBp">
        </div>
      </div>
      <!-- amount -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.amount' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.financing.monthlyFee">
        </div>
      </div>
      <!-- wayToPay -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.wayToPay' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.financing.wayToPay.name">
        </div>
      </div>
      <!-- ceco -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.ceco' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.ceco.description">
        </div>
      </div>
      <!-- interestType -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{ 'tableManagement.real-state.interestType' | translate }}
                </label>
          <input type="text" class="form-control custom-input" [(ngModel)]="entity.financing.interestRate">
        </div>
      </div>
      <!-- ACTIVE -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="insuranceType-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.active' | translate }}
                </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="active">
        </div>
      </div>
    </div>
    <!-- #endregion BODY -->
</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          <!-- <div *ngIf="isNew">
          <button class="btn custom-button" (click)="save()" i18n>
            {{'general.create' | translate}}
          </button>
        </div> -->
        @if (!isNew) {
          <div>
            <button class="btn custom-button" (click)="saveChanges()" i18n>
                        {{'general.save' | translate}}
                    </button>
          </div>
        }
      </div>
    </div>
  </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}